import lodash from "lodash";
class AudioPluginService {
  createLoadingData(file, url, componentData) {
    const isCoverImageData = file.type.includes("image");
    if (isCoverImageData) return { componentData };
    const { html, authorName, name, coverImage, ...rest } = componentData;
    return {
      componentData: {
        ...rest,
        audio: { src: { id: url } },
        name: name || file.name.split(".")[0],
        authorName
      },
      componentState: {
        tempData: true,
        loading: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    const { html, tempData, loading, ...rest } = componentData;
    const data = uploadedData.data;
    const isCoverImageData = data?.file_name;
    const name = data?.name ?? componentData?.name;
    const authorName = data?.authorName ?? componentData?.authorName;
    const audio = data?.audio ?? componentData?.audio;
    let coverImage;
    if (isCoverImageData) {
      coverImage = { src: { id: data.file_name } };
    }
    return {
      ...rest,
      audio,
      name,
      authorName,
      coverImage
    };
  }
  createErrorData(error, componentData) {
    return {
      ...lodash.omit(componentData, ["tempData"]),
      error
    };
  }
}
export {
  AudioPluginService
};
//# sourceMappingURL=audioPluginService.js.map
